import { h, Host, } from "@stencil/core";
import { PageChangeEventType } from "./types";
import { ICON_NAMESPACE } from "../../icons/namespace";
/**
 * Page navigation with ability to jump to first and last pages with `pageCount` is provided.
 */
export class Pagination {
  constructor() {
    this.triggerPageChange = (e) => {
      this.update.emit(e);
    };
    this.first = () => {
      this.triggerPageChange(PageChangeEventType.First);
    };
    this.previous = () => {
      this.triggerPageChange(PageChangeEventType.Previous);
    };
    this.next = () => {
      this.triggerPageChange(PageChangeEventType.Next);
    };
    this.last = () => {
      this.triggerPageChange(PageChangeEventType.Last);
    };
    this.pageCount = undefined;
    this.current = undefined;
  }
  render() {
    const finite = this.pageCount != null;
    return (h(Host, { role: 'navigation', "aria-label": 'pagination' }, finite && (h("es-button", { role: 'button', "aria-label": 'First page', variant: 'minimal', disabled: this.current === 1, onClick: this.first }, h("es-icon", { icon: [ICON_NAMESPACE, 'chevron-double'], angle: 90, size: 12 }))), h("es-button", { role: 'button', "aria-label": 'Previous page', variant: 'minimal', disabled: this.current === 1, onClick: this.previous }, h("es-icon", { icon: [ICON_NAMESPACE, 'chevron'], angle: 90, size: 12 })), h("div", null, h("span", null, this.current), finite && (h("span", { class: 'page-count' }, " / ", this.pageCount))), h("es-button", { role: 'button', "aria-label": 'Next page', variant: 'minimal', disabled: this.current === this.pageCount && finite, onClick: this.next }, h("es-icon", { icon: [ICON_NAMESPACE, 'chevron'], angle: -90, size: 12 })), finite && (h("es-button", { role: 'button', "aria-label": 'Last page', variant: 'minimal', disabled: this.current === this.pageCount && finite, onClick: this.last }, h("es-icon", { icon: [ICON_NAMESPACE, 'chevron-double'], angle: -90, size: 12 })))));
  }
  static get is() { return "es-pagination"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-pagination.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-pagination.css"]
    };
  }
  static get properties() {
    return {
      "pageCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number | undefined",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Number of pages."
        },
        "attribute": "page-count",
        "reflect": false
      },
      "current": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Current Page."
        },
        "attribute": "current",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "update",
        "name": "update",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Triggered when a pagination button is clicked"
        },
        "complexType": {
          "original": "PageChangeEventType",
          "resolved": "PageChangeEventType.First | PageChangeEventType.Last | PageChangeEventType.Next | PageChangeEventType.Previous",
          "references": {
            "PageChangeEventType": {
              "location": "import",
              "path": "./types",
              "id": "src/components/es-pagination/types.ts::PageChangeEventType"
            }
          }
        }
      }];
  }
}
//# sourceMappingURL=es-pagination.js.map
